// src/router.js
import { createRouter, createWebHashHistory } from "vue-router";
import Login from "../components/Login.vue";
import Otp from "../components/Otp.vue";
import Home from "../components/Home.vue";
import Survey from "../components/Survey.vue";
import AddingQAndC from "../components/AddingQAndC.vue";
import User from "../components/User.vue";
import QandCManagement from "../components/QandCManagement.vue";
import UserManagement from "../components/UserManagement.vue";
import Surveygroup from "../components/SurveyGroup.vue";
import MyActivityReport from "../components/MyActivityReport.vue";
import AreaActivityReport from "../components/AreaActivityReport.vue";
import PhoneData from "../components/PhoneData.vue";


const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/otp",
    name: "Otp",
    component: Otp,
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/survey",
    name: "Survey",
    component: Survey,
  },
  {
    path: "/addingqandc",
    name: "AddingQAndC",
    component: AddingQAndC,
  },
  {
    path: "/user",
    name: "User",
    component: User,
  },
  {
    path: "/qandcmanagement",
    name: "QandCManagement",
    component: QandCManagement,
  },
  {
    path: "/userManagement",
    name: "UserManagement",
    component: UserManagement,
  },
  {
    path: "/surveygroup",
    name: "Surveygroup",
    component: Surveygroup,
  },
  {
    path: "/myactivityreport",
    name: "MyActivityReport",
    component: MyActivityReport,
  },
  {
    path: "/areaactivityreport",
    name: "AreaActivityReport",
    component: AreaActivityReport,
  },
  {
    //Encode path to avoid anonymous access 
    path: "/iwu73651@9120",
    name: "PhoneData",
    component: PhoneData,
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
